import React, { useState, useEffect } from "react";
import {
  Box,
  Grid,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TableHead,
  Avatar,
  Modal,
  styled,
  Paper,
  Divider,
  Autocomplete,
  TextField,
  Tab,
  Tabs
} from "@mui/material";
import { toast } from "sonner";
import PaymentRoundedIcon from "@mui/icons-material/PaymentRounded";
import ReceiptRoundedIcon from "@mui/icons-material/ReceiptRounded";
import { fetchToken } from "../auth/Token";
import { api } from './../api';
import { decode } from "base-64";
import { useLocation, useNavigate } from "react-router-dom";
import PropTypes from 'prop-types';


const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(2),
    borderStyle: 'groove',
    border: '3px',
    borderColor:'grey',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2), 0 6px 20px rgba(0, 0, 0, 0.2)',
    marginTop: '10px',
    minHeight:'50px',
    borderRadius:'10px'
}));

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const Salaries = () => {
  const [current_payroll, setCurrent_payroll] = useState([]);
  const [current_payroll_info, setCurrent_payroll_info] = useState([]);
  const [period, setPeriod] = useState(new Date().toISOString().slice(0, 7));
  const [salary_modal, setSalary_modal] = useState(false);
  const [salary_fill, setSalary_fill] = useState([]);
  const [netSalary, setNetSalary] = useState(null);
  const [bank_accounts, setBank_accounts] = useState([]);
  const [selected_bank, setSelected_bank] = useState(null);
  const [main_account, setMain_account] = useState([]);
  const [expense_accounts, setExpense_accounts] = useState([]);
  const [selected_expense, setSelected_expense] = useState(null);
  const [which_people, setWhich_people] = useState("both");
  const location = useLocation();
  const society_id = location.state && location.state.society_id;
  const [value1, setValue1] = useState(0);
  const [mainT, setMainT] = useState(false);

  const handleMain = () => {
    setSelected_bank(main_account?.Main?.id);
    setMainT(true)
  }

  const handleChange1 = (event, newValue) => {
    setValue1(newValue);
  };

  const handleStaff = () => {
    if(which_people === "both"){
      setWhich_people("staff")
    } else {
      setWhich_people("both")
    }
  }

  const printWaybill = (id) => {
    toast.promise(
      api.get(`/users/generate/salary/payslip/${id}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
        responseType: "blob",
      }),
      {
        loading: "Generating payslip...",
        success: (response) => {
          // Create a URL for the blob
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const a = document.createElement('a');
          a.href = url;
          a.download = `payslip_${id}.pdf`; 
          document.body.appendChild(a);
          a.click(); // Trigger the download
          a.remove(); // Clean up

          return "Payslip generated successfully!";

        },
        error: (error) => {
          console.log(error);

          return "Error, Please Refresh page";
        },
      }
    )
  }

  const pay_salary = () => {
    const data = new FormData()
    data.append("society_id", society_id)
    data.append("netSalary", netSalary)
    data.append("paye_salary_id", salary_fill?.id)
    data.append("expense_id", selected_expense)
    // if(mainT === true){
    //   data.append("ecash_id", selected_bank)
    // } else {
    //   data.append("bank_id", selected_bank)
    // }
    // console.log(mainT)

    toast.promise(
      api.post("/users/pay/salary", data, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      }),
      {
        loading: "Processing request...",
        success: (response) => {
          closeSalaryModal();
          getSalaryData();

          return response.data;

        },
        error: (error) => {
          console.log(error);

          return "Error, Please Refresh page";
        },
      }
    )


  }

  const calculatePAYE = (basicSalary) => {
    // Monthly tax bands
  const bands = [
    { limit:  490.00,   rate: 0.00 },   // 0%
    { limit:  110.00,   rate: 0.05 },   // 5%
    { limit:  130.00,   rate: 0.10 },   // 10%
    { limit: 3166.67,   rate: 0.175 },  // 17.5%
    { limit: 16000.00,  rate: 0.25 },   // 25%
    { limit: 30520.00,  rate: 0.30 },   // 30%
    { limit: Infinity,  rate: 0.35 },   // 35% for anything above 50,416.67
  ];

  let remaining = basicSalary;
  let totalTax = 0;

  for (let i = 0; i < bands.length; i++) {
    if (remaining <= 0) {
      break; // No more salary left to tax
    }

    const { limit, rate } = bands[i];
    // The portion taxed at this band's rate is the smaller of 'remaining' vs. 'limit'
    const taxablePortion = Math.min(remaining, limit);
    
    totalTax += taxablePortion * rate;
    remaining -= taxablePortion;
  }

  return totalTax;
  };

  useEffect(() => {
    const basicSalary = salary_fill?.basic_salary ?? 0;

    // 3. Calculate each deduction
    const payeTax = calculatePAYE(basicSalary);
    const ssnitTier2 = basicSalary * 0.055;
    const providentFund = basicSalary * 0.05;
    const withholdingTax = basicSalary * 0.05;
    const ssnitTier1 = basicSalary * 0.13; // covered by cooperative

    // 4. Compute Net Salary (Gross minus employee‐side deductions)
    //    SSNIT Tier 1 is not subtracted since it is covered by cooperative.
    if(salary_fill?.staff === false){
      setNetSalary(basicSalary - withholdingTax)
    } else {
      setNetSalary(basicSalary - (payeTax + ssnitTier2 + providentFund))
    }
    
  },[salary_fill])


  const closeSalaryModal = () => {
    setSalary_modal(false);
    setSalary_fill([]);
    setNetSalary(null);
    setBank_accounts(null);
    setSelected_bank(null);
    setMainT(false)
    setSelected_expense(null);
  }

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "90%",
    maxHeight: "80vh",
    minHeight: "70vh",
    overflowY: "auto",
    "&::-webkit-scrollbar": {
      width: "7px",
    },
    "&::-webkit-scrollbar-track": {
      background: "#f1f1f1",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#888",
      borderRadius: "10px",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      background: "#555",
    },
    bgcolor: "background.paper",
    borderRadius: "7px",
    boxShadow: 24,
    p: 4,
  };

  const openPaySalary = (row) => {
    setSalary_modal(true);
    setSalary_fill(row);
  }

  const pic = (pic) => {
    const de = decode(pic);
    return `data:image/jpeg;base64,${btoa(de)}`;
  };

  const getSalaryData = () => {
    
    const data = new FormData();
    data.append("month", period);
    data.append("society_id", society_id);
    data.append("which_people", value1);

    toast.promise(
      api.post("/users/salaries/data", data, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      }),
      {
        loading: "Fetching...",
        success: (response) => {
          setCurrent_payroll(response.data.salaries);
          setCurrent_payroll_info(response.data);

          return "Data Loaded Successfully";
        },
        error: (error) => {
          console.log(error);

          return "Error, Please Refresh page";
        },
      }
    );
    
    toast.promise(
      api.get("/users/salaries/data/update", {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      }),
      {
        loading: "Fetching...",
        success: (response) => {

          return "Data Loaded Successfully";
        },
        error: (error) => {
          console.log(error);

          return "Error, Please Refresh page";
        },
      }
    );

    toast.promise(
      api.get(`/account/society/all/expense/${society_id}`, {
          headers: {
          Authorization: "Bearer " + fetchToken(),
          },
      }),
      {
          loading: 'Loading bank accounts...',
          success: (response) => {
              setBank_accounts(response.data?.Banks);
              setExpense_accounts(response.data?.Accounts);
              setMain_account(response.data);

              return 'Loaded Successfully'
          },
          error: (error) => {
              console.log(error);

              return 'An error occurred, Please try again'
          }
      }
    )
  };

  useEffect(() => {
    getSalaryData();
  }, [value1]);


  useEffect(() => {
    getSalaryData();
  }, [period]);


  function formatDateToYearMonthDay(date) {
    const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
    ];
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    let suffix = "th";

    if (day === 1 || day === 21 || day === 31) {
    suffix = "st";
    } else if (day === 2 || day === 22) {
    suffix = "nd";
    } else if (day === 3 || day === 23) {
    suffix = "rd";
    }

    return `${day}${suffix} ${month} ${year}`;
}

  function formatDateToYearMonth(date) {
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const month = months[date.getMonth()];
    const year = date.getFullYear();

    return `${month} ${year}`;
  }

  
  const currencyFormat = new Intl.NumberFormat('en-GH', {
    style: 'currency',
    currency: 'GHS',
  });




  return (
    <div className="app">
      <main className="content">
        <Box sx={{ m: 3 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={12}>
              <Typography
                sx={{ textAlign: "center" }}
                variant="h3"
                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
              >
                <b>{which_people === "staff" ? "Staff": "Users"} Payrolls</b>
              </Typography>
              
            </Grid>
            <Grid item xs={12} md={12}>
              <Box sx={{ width: '100%' }}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                  <Tabs value={value1} onChange={handleChange1} aria-label="basic tabs example">
                    <Tab label={<b style={{ fontStyle: 'normal', fontFamily:"'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" }}>All Users</b>} {...a11yProps(0)} />
                    <Tab label={<b style={{ fontStyle: 'normal', fontFamily:"'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" }}>Staff</b>} {...a11yProps(1)} />
                    <Tab label={<b style={{ fontStyle: 'normal', fontFamily:"'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" }}>Non-Staff</b>} {...a11yProps(2)} />
                  </Tabs>
                </Box>
                <CustomTabPanel value={value1} index={0}>
                  <Grid item xs={12} md={4}>
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                      <b>Select Month: </b>
                    </Typography>

                    <TextField
                      sx={{ m:1 }}
                      size="small"
                      name="period"
                      type="month" 
                      value={period}
                      onChange={(e) => setPeriod(e.target.value)}
                      inputProps={{
                        max: new Date(new Date().setMonth(new Date().getMonth() + 2))
                          .toISOString()
                          .slice(0, 7)
                      }}
                      fullWidth
                    />
                  </Grid> 

                  <Grid item xs={12} md={12}>
                    <Item>
                      <Box sx={{display:'flex', flexDirection:'row', justifyContent:'space-around'}}>
                        <Box>
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Period: {formatDateToYearMonth(new Date(period))}</b>
                          </Typography>
                          <Typography sx={{ color:'blue' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Paid: {currencyFormat.format(current_payroll_info?.paid)}</b>
                          </Typography>

                          <Typography sx={{ color:'red' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Unpaid: {currencyFormat.format(current_payroll_info?.unpaid)}</b>
                          </Typography>

                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Total Gross Salary: {currencyFormat.format(current_payroll_info?.total_gross_salary)}</b>
                          </Typography>
                        </Box>

                        <Box>
                          <Typography sx={{ textAlign:'center' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Deductions (TOTALS)</b>
                          </Typography>
                          <Divider variant="middle" sx={{ m:.5 }}/>

                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>PAYE Tax: {currencyFormat.format(current_payroll_info?.total_tax_deductions)}</b>
                          </Typography>
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>SSNIT Contribution Tier 2: {currencyFormat.format(current_payroll_info?.total_snnit2_deductions)}</b>
                          </Typography>
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Provident Fund: {currencyFormat.format(current_payroll_info?.total_prfund_deductions)}</b>
                          </Typography>
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Withholding Tax (WHT): {currencyFormat.format(current_payroll_info?.total_wht_deductions)}</b>
                          </Typography>

                          <Typography sx={{ textAlign:'center' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Covered by Cooperative</b>
                          </Typography>
                          <Divider sx={{ m:.5 }}/>
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>SSNIT Contribution Tier 1: {currencyFormat.format(current_payroll_info?.total_cooperative_covers)}</b>
                          </Typography>
                        </Box>
                        <Box>
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Total Salary Expense: <span style={{ color:'red' }}>{currencyFormat.format(current_payroll_info?.total_cooperative_covers + current_payroll_info?.total_gross_salary)}</span></b>
                          </Typography>
                        </Box>
                      </Box>
                    </Item>
                  </Grid>
                  
                  

                  <Grid item xs={12} md={12}>
                    <Box
                      sx={{
                        overflow: "auto",
                        marginBottom: 10,
                        maxHeight: 340,
                        "&::-webkit-scrollbar": {
                          width: "7px",
                          height: "7px",
                        },
                        "&::-webkit-scrollbar-track": {
                          background: "#f1f1f1",
                        },
                        "&::-webkit-scrollbar-thumb": {
                          background: "#888",
                          borderRadius: "10px",
                        },
                        "&::-webkit-scrollbar-thumb:hover": {
                          background: "#555",
                        },
                      }}
                    >
                      <Table size="small" aria-label="a dense table">
                        <TableHead>
                          <TableRow>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b></b>
                              </Typography>{" "}
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>User</b>
                              </Typography>{" "}
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Gross Salary</b>
                              </Typography>{" "}
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Phone</b>
                              </Typography>{" "}
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Main Society</b>
                              </Typography>{" "}
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Role</b>
                              </Typography>{" "}
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Salary Status</b>
                              </Typography>{" "}
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Pay</b>
                              </Typography>{" "}
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Pay Slip</b>
                              </Typography>{" "}
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {current_payroll?.map((row, index) => (
                            <TableRow
                              key={row.id}
                              sx={{
                                "&:last-child td, &:last-child th": {
                                  border: 0,
                                },
                                backgroundColor: "#f5f3f4",
                              }}
                            >
                              <TableCell align="left">
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <Avatar src={pic(row.userImage)} />
                                </Typography>
                              </TableCell>
                              <TableCell align="left">
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>{row.username}</b>
                                </Typography>
                              </TableCell>
                              <TableCell align="left">
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>{currencyFormat.format(row.basic_salary)}</b>
                                </Typography>
                              </TableCell>
                              <TableCell align="left">
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>{row.phone}</b>
                                </Typography>
                              </TableCell>
                              <TableCell align="left">
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>{row.society}</b>
                                </Typography>
                              </TableCell>
                              <TableCell align="left">
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>{row.role_name}</b>
                                </Typography>
                              </TableCell>
                              <TableCell align="left">
                                <Typography sx={{ color:row.status === 'Unpaid'?'red': 'blue' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>{row.status}</b>
                                </Typography>
                              </TableCell>
                              <TableCell align="left">
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <Button
                                    size="small"
                                    color="success"
                                    variant="contained"
                                    disabled={row.status === "Paid" || row.status === "Processing"}
                                    sx={{
                                      borderRadius: 2,
                                      boxShadow:
                                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                      "&:hover": {
                                        boxShadow:
                                          "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                        backgroundColor: "#14213d",
                                      },
                                    }}
                                    onClick={() => openPaySalary(row)}
                                  >
                                    <PaymentRoundedIcon />
                                  </Button>
                                </Typography>
                              </TableCell>
                              <TableCell align="left">
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <Button
                                    size="small"
                                    color="success"
                                    variant="contained"
                                    disabled={row.status === "Unpaid" || row.status === "Processing"}
                                    sx={{
                                      borderRadius: 2,
                                      boxShadow:
                                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                      "&:hover": {
                                        boxShadow:
                                          "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                        backgroundColor: "#14213d",
                                      },
                                    }}
                                    onClick={() => printWaybill(row.id)}
                                  >
                                    <ReceiptRoundedIcon />
                                  </Button>
                                </Typography>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </Box>
                  </Grid>
                </CustomTabPanel>
                <CustomTabPanel value={value1} index={1}>
                <Grid item xs={12} md={4}>
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                      <b>Select Month: </b>
                    </Typography>

                    <TextField
                      sx={{ m:1 }}
                      size="small"
                      name="period"
                      type="month" 
                      value={period}
                      onChange={(e) => setPeriod(e.target.value)}
                      inputProps={{
                        max: new Date(new Date().setMonth(new Date().getMonth() + 2))
                          .toISOString()
                          .slice(0, 7)
                      }}
                      fullWidth
                    />
                  </Grid> 

                  <Grid item xs={12} md={12}>
                    <Item>
                      <Box sx={{display:'flex', flexDirection:'row', justifyContent:'space-around'}}>
                        <Box>
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Period: {formatDateToYearMonth(new Date(period))}</b>
                          </Typography>
                          <Typography sx={{ color:'blue' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Paid: {currencyFormat.format(current_payroll_info?.paid)}</b>
                          </Typography>

                          <Typography sx={{ color:'red' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Unpaid: {currencyFormat.format(current_payroll_info?.unpaid)}</b>
                          </Typography>

                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Total Gross Salary: {currencyFormat.format(current_payroll_info?.total_gross_salary)}</b>
                          </Typography>
                        </Box>

                        <Box>
                          <Typography sx={{ textAlign:'center' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Deductions (TOTALS)</b>
                          </Typography>
                          <Divider variant="middle" sx={{ m:.5 }}/>

                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>PAYE Tax: {currencyFormat.format(current_payroll_info?.total_tax_deductions)}</b>
                          </Typography>
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>SSNIT Contribution Tier 2: {currencyFormat.format(current_payroll_info?.total_snnit2_deductions)}</b>
                          </Typography>
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Provident Fund: {currencyFormat.format(current_payroll_info?.total_prfund_deductions)}</b>
                          </Typography>

                          <Typography sx={{ textAlign:'center' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Covered by Cooperative</b>
                          </Typography>
                          <Divider sx={{ m:.5 }}/>
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>SSNIT Contribution Tier 1: {currencyFormat.format(current_payroll_info?.total_cooperative_covers)}</b>
                          </Typography>
                        </Box>
                        <Box>
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Total Salary Expense: <span style={{ color:'red' }}>{currencyFormat.format(current_payroll_info?.total_cooperative_covers + current_payroll_info?.total_gross_salary)}</span></b>
                          </Typography>
                        </Box>
                      </Box>
                    </Item>
                  </Grid>
                  
                  

                  <Grid item xs={12} md={12}>
                    <Box
                      sx={{
                        overflow: "auto",
                        marginBottom: 10,
                        maxHeight: 340,
                        "&::-webkit-scrollbar": {
                          width: "7px",
                          height: "7px",
                        },
                        "&::-webkit-scrollbar-track": {
                          background: "#f1f1f1",
                        },
                        "&::-webkit-scrollbar-thumb": {
                          background: "#888",
                          borderRadius: "10px",
                        },
                        "&::-webkit-scrollbar-thumb:hover": {
                          background: "#555",
                        },
                      }}
                    >
                      <Table size="small" aria-label="a dense table">
                        <TableHead>
                          <TableRow>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b></b>
                              </Typography>{" "}
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>User</b>
                              </Typography>{" "}
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Gross Salary</b>
                              </Typography>{" "}
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Phone</b>
                              </Typography>{" "}
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Main Society</b>
                              </Typography>{" "}
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Role</b>
                              </Typography>{" "}
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Salary Status</b>
                              </Typography>{" "}
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Pay</b>
                              </Typography>{" "}
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Pay Slip</b>
                              </Typography>{" "}
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {current_payroll?.map((row, index) => (
                            <TableRow
                              key={row.id}
                              sx={{
                                "&:last-child td, &:last-child th": {
                                  border: 0,
                                },
                                backgroundColor: "#f5f3f4",
                              }}
                            >
                              <TableCell align="left">
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <Avatar src={pic(row.userImage)} />
                                </Typography>
                              </TableCell>
                              <TableCell align="left">
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>{row.username}</b>
                                </Typography>
                              </TableCell>
                              <TableCell align="left">
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>{currencyFormat.format(row.basic_salary)}</b>
                                </Typography>
                              </TableCell>
                              <TableCell align="left">
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>{row.phone}</b>
                                </Typography>
                              </TableCell>
                              <TableCell align="left">
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>{row.society}</b>
                                </Typography>
                              </TableCell>
                              <TableCell align="left">
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>{row.role_name}</b>
                                </Typography>
                              </TableCell>
                              <TableCell align="left">
                                <Typography sx={{ color:row.status === 'Unpaid'?'red': 'blue' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>{row.status}</b>
                                </Typography>
                              </TableCell>
                              <TableCell align="left">
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <Button
                                    size="small"
                                    color="success"
                                    variant="contained"
                                    disabled={row.status === "Paid"}
                                    sx={{
                                      borderRadius: 2,
                                      boxShadow:
                                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                      "&:hover": {
                                        boxShadow:
                                          "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                        backgroundColor: "#14213d",
                                      },
                                    }}
                                    onClick={() => openPaySalary(row)}
                                  >
                                    <PaymentRoundedIcon />
                                  </Button>
                                </Typography>
                              </TableCell>
                              <TableCell align="left">
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <Button
                                    size="small"
                                    color="success"
                                    variant="contained"
                                    disabled={row.status === "Unpaid"}
                                    sx={{
                                      borderRadius: 2,
                                      boxShadow:
                                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                      "&:hover": {
                                        boxShadow:
                                          "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                        backgroundColor: "#14213d",
                                      },
                                    }}
                                    onClick={() => printWaybill(row.id)}
                                  >
                                    <ReceiptRoundedIcon />
                                  </Button>
                                </Typography>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </Box>
                  </Grid>
                </CustomTabPanel>
                <CustomTabPanel value={value1} index={2}>
                <Grid item xs={12} md={4}>
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                      <b>Select Month: </b>
                    </Typography>

                    <TextField
                      sx={{ m:1 }}
                      size="small"
                      name="period"
                      type="month" 
                      value={period}
                      onChange={(e) => setPeriod(e.target.value)}
                      inputProps={{
                        max: new Date(new Date().setMonth(new Date().getMonth() + 2))
                          .toISOString()
                          .slice(0, 7)
                      }}
                      fullWidth
                    />
                  </Grid> 

                  <Grid item xs={12} md={12}>
                    <Item>
                      <Box sx={{display:'flex', flexDirection:'row', justifyContent:'space-around'}}>
                        <Box>
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Period: {formatDateToYearMonth(new Date(period))}</b>
                          </Typography>
                          <Typography sx={{ color:'blue' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Paid: {currencyFormat.format(current_payroll_info?.paid)}</b>
                          </Typography>

                          <Typography sx={{ color:'red' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Unpaid: {currencyFormat.format(current_payroll_info?.unpaid)}</b>
                          </Typography>

                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Total Gross Salary: {currencyFormat.format(current_payroll_info?.total_gross_salary)}</b>
                          </Typography>
                        </Box>

                        <Box>
                          <Typography sx={{ textAlign:'center' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Deductions (TOTALS)</b>
                          </Typography>
                          <Divider variant="middle" sx={{ m:.5 }}/>

                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Withholding Tax (WHT): {currencyFormat.format(current_payroll_info?.total_wht_deductions)}</b>
                          </Typography>
                        </Box>
                        <Box>
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Total Salary Expense: <span style={{ color:'red' }}>{currencyFormat.format(current_payroll_info?.total_gross_salary)}</span></b>
                          </Typography>
                        </Box>
                      </Box>
                    </Item>
                  </Grid>
                  
                  

                  <Grid item xs={12} md={12}>
                    <Box
                      sx={{
                        overflow: "auto",
                        marginBottom: 10,
                        maxHeight: 340,
                        "&::-webkit-scrollbar": {
                          width: "7px",
                          height: "7px",
                        },
                        "&::-webkit-scrollbar-track": {
                          background: "#f1f1f1",
                        },
                        "&::-webkit-scrollbar-thumb": {
                          background: "#888",
                          borderRadius: "10px",
                        },
                        "&::-webkit-scrollbar-thumb:hover": {
                          background: "#555",
                        },
                      }}
                    >
                      <Table size="small" aria-label="a dense table">
                        <TableHead>
                          <TableRow>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b></b>
                              </Typography>{" "}
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>User</b>
                              </Typography>{" "}
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Gross Salary</b>
                              </Typography>{" "}
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Phone</b>
                              </Typography>{" "}
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Main Society</b>
                              </Typography>{" "}
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Role</b>
                              </Typography>{" "}
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Salary Status</b>
                              </Typography>{" "}
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Pay</b>
                              </Typography>{" "}
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Pay Slip</b>
                              </Typography>{" "}
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {current_payroll?.map((row, index) => (
                            <TableRow
                              key={row.id}
                              sx={{
                                "&:last-child td, &:last-child th": {
                                  border: 0,
                                },
                                backgroundColor: "#f5f3f4",
                              }}
                            >
                              <TableCell align="left">
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <Avatar src={pic(row.userImage)} />
                                </Typography>
                              </TableCell>
                              <TableCell align="left">
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>{row.username}</b>
                                </Typography>
                              </TableCell>
                              <TableCell align="left">
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>{currencyFormat.format(row.basic_salary)}</b>
                                </Typography>
                              </TableCell>
                              <TableCell align="left">
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>{row.phone}</b>
                                </Typography>
                              </TableCell>
                              <TableCell align="left">
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>{row.society}</b>
                                </Typography>
                              </TableCell>
                              <TableCell align="left">
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>{row.role_name}</b>
                                </Typography>
                              </TableCell>
                              <TableCell align="left">
                                <Typography sx={{ color:row.status === 'Unpaid'?'red': 'blue' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>{row.status}</b>
                                </Typography>
                              </TableCell>
                              <TableCell align="left">
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <Button
                                    size="small"
                                    color="success"
                                    variant="contained"
                                    disabled={row.status === "Paid"}
                                    sx={{
                                      borderRadius: 2,
                                      boxShadow:
                                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                      "&:hover": {
                                        boxShadow:
                                          "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                        backgroundColor: "#14213d",
                                      },
                                    }}
                                    onClick={() => openPaySalary(row)}
                                  >
                                    <PaymentRoundedIcon />
                                  </Button>
                                </Typography>
                              </TableCell>
                              <TableCell align="left">
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <Button
                                    size="small"
                                    color="success"
                                    variant="contained"
                                    disabled={row.status === "Unpaid"}
                                    sx={{
                                      borderRadius: 2,
                                      boxShadow:
                                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                      "&:hover": {
                                        boxShadow:
                                          "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                        backgroundColor: "#14213d",
                                      },
                                    }}
                                    onClick={() => printWaybill(row.id)}
                                  >
                                    <ReceiptRoundedIcon />
                                  </Button>
                                </Typography>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </Box>
                  </Grid>
                </CustomTabPanel>
              </Box>
            </Grid>

            
          </Grid>
          
          <Modal
              open={salary_modal}
              onClose={closeSalaryModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <Item>
                        <Avatar sx={{ width: 150, height: 150, mx:'auto' }} src={pic(salary_fill?.userImage ?salary_fill?.userImage:null)} />
                        <Divider variant='middle' sx={{ m:1 }} />
                        <Box sx={{display:'flex', flexDirection:'row', justifyContent:'space-around'}}>
                          <Box>
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>User: {salary_fill?.username}</b>
                            </Typography>
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Gender: {salary_fill?.gender}</b>
                            </Typography>
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Date of Birth: {formatDateToYearMonthDay(new Date(salary_fill?.dob))}</b>
                            </Typography>
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Role: {salary_fill?.role_name}</b>
                            </Typography>
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Society: {salary_fill?.society}</b>
                            </Typography>
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Registration Date: {formatDateToYearMonthDay(new Date(salary_fill?.date_joined))}</b>
                            </Typography>
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Cooperative Registration Number: {salary_fill?.crn}</b>
                            </Typography>
                          </Box>
                          {/* <Divider variant='middle' sx={{ m:1 }} orientation="vertical" flexItem/> */}
                          <Box>
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Contact Phone: {salary_fill?.phone}</b>
                            </Typography>
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Email: {salary_fill?.email}</b>
                            </Typography>
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Address: {salary_fill?.address}</b>
                            </Typography>
                            <Divider sx={{ m:.5 }}/>
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Account Provider: {salary_fill?.bank_name}</b>
                            </Typography>
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Account Name: {salary_fill?.account_name}</b>
                            </Typography>
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Account Number: {salary_fill?.account_number}</b>
                            </Typography>
                            {
                              salary_fill?.staff === true?
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>SSNIT Number: {salary_fill?.sinn_number}</b>
                              </Typography>
                              :null
                            }
                            
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>GRA PIN: {salary_fill?.gra_pin}</b>
                            </Typography>
                          </Box>
                        </Box>
                      </Item>
                    </Grid>
                    
                    <Grid item xs={12} md={6}>
                      <Item>
                        <Typography sx={{ textAlign:'center' }} variant="h2" fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>{salary_fill?.staff === false? "Allowance": "Gross Salary"}: {currencyFormat.format(salary_fill?.basic_salary)}</b>
                        </Typography>
                        <Divider variant='middle' sx={{ m:1 }} />
                        <Box sx={{display:'flex', flexDirection:'row', justifyContent:'space-around'}}>
                          <Box>
                            <Typography sx={{ textAlign:'center' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Deductions</b>
                            </Typography>
                            <Divider sx={{ m:.5 }}/>
                            
                            {
                              salary_fill?.staff === false?
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Withholding Tax (WHT)(5%): <span style={{ color:'red' }}>{currencyFormat.format(salary_fill?.basic_salary * 0.05)}</span></b>
                              </Typography>
                              :
                              <>
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>PAYE Tax: <span style={{ color:'red' }}>{currencyFormat.format(calculatePAYE(salary_fill?.basic_salary))}</span></b>
                                </Typography>
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>SSNIT Contribution Tier 2(5.5%): <span style={{ color:'red' }}>{currencyFormat.format(salary_fill?.basic_salary * 0.055)}</span></b>
                                </Typography>
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>Provident Fund(5%): <span style={{ color:'red' }}>{currencyFormat.format(salary_fill?.basic_salary * 0.05)}</span></b>
                                </Typography>
                              </>
                            }
                            
                          </Box>
                          {
                            salary_fill?.staff === false?
                            <Box>
                              <Typography sx={{ textAlign:'center' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Covered by Cooperative</b>
                              </Typography>
                              <Divider sx={{ m:.5 }}/>
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>SSNIT Contribution Tier 1(13%): <span style={{ color:'red' }}>{currencyFormat.format(salary_fill?.basic_salary * 0.13)}</span></b>
                              </Typography>
                            </Box>
                          :null
                          }
                          
                        </Box>
                        <Divider variant='middle' sx={{ m:1 }} />
                        <Typography sx={{ textAlign:'center', color:'green', my:10.5 }} variant="h1" fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>{salary_fill?.staff === false? "Net Allowance": "Net Salary"}: {currencyFormat.format(netSalary)}</b>
                        </Typography>
                      </Item>
                    </Grid>

                    <Grid item xs={12} md={12}>
                      <Item>
                        <Box sx={{ display:'flex' }}>
                          {/* <Button
                              size="small"
                              color="success"
                              variant={mainT? "contained": "outlined"}
                              sx={{
                                  borderRadius: 2,
                                  mx:2,
                                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                  "&:hover": {
                                  boxShadow: "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                  backgroundColor: "#14213d",
                                  },
                              }}
                              onClick={handleMain}
                          >
                              <Typography
                                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                              >
                                  <b>Main Wallet Account | {currencyFormat.format(main_account?.Main?.current_balance)}</b>
                              </Typography>
                          </Button>
                          {
                            !mainT?
                            <Autocomplete
                              id="tags-outlined"
                              options={bank_accounts}
                              sx={{ width:'30%', mr:2 }}
                              getOptionLabel={(option) => option.account_name}
                              isOptionEqualToValue={(option, value) =>
                                  option.account_name === value.id
                              }
                              getOptionDisabled={(option) => netSalary > option.current_balance}
                              onChange={(event, value) =>
                                setSelected_bank(value.id)
                              }
                              filterSelectedOptions
                              renderInput={(params) => (
                              <TextField
                                  {...params}
                                  helperText="Account to make payment from"
                                  size="small"
                              />
                              )}
                            />
                            :null
                          } */}
                          
                          
                          <Autocomplete
                            id="tags-outlined"
                            options={expense_accounts}
                            sx={{ width:'30%' }}
                            getOptionLabel={(option) => option.account_name}
                            isOptionEqualToValue={(option, value) =>
                                option.account_name === value.id
                            }
                            onChange={(event, value) =>
                              setSelected_expense(value.id)
                            }
                            filterSelectedOptions
                            renderInput={(params) => (
                            <TextField
                                {...params}
                                helperText="Ledger to save record"
                                size="small"
                            />
                            )}
                          />

                          <Button
                            size="small"
                            color="error"
                            variant="contained"
                            sx={{
                            borderRadius: 2,
                            m: 1,
                            boxShadow:
                                "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                            "&:hover": {
                                boxShadow:
                                "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                backgroundColor: "#14213d",
                            },
                            }}
                            onClick={closeSalaryModal}
                          >
                            Close
                          </Button>

                          <Button
                            size="small"
                            color="success"
                            variant="contained"
                            sx={{
                            borderRadius: 2,
                            m: 1,
                            boxShadow:
                                "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                            "&:hover": {
                                boxShadow:
                                "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                backgroundColor: "#14213d",
                            },
                            }}
                            onClick={pay_salary}
                            disabled={!selected_expense || !netSalary}
                          >
                            Complete Request
                          </Button>
                        </Box>

                      </Item>
                    </Grid>
                </Grid>
            </Box>
          </Modal>
          
        </Box>
      </main>
    </div>
  );
};

export default Salaries;
